import TaxiCorporationOrderBillingsListRequest, {
  TaxiCorporationOrderBillingsListRequestBillingModel,
  TaxiCorporationOrderBillingsListRequestBillingType,
  TaxiCorporationOrderBillingsListRequestOrder,
  TaxiCorporationOrderBillingsListRequestStatus,
} from "../../../../api/raily/taxi-corporation/order-billings/list/taxi-corporation-order-billings-list.request";
import BillingModel from "../../../../types/billing-model";
import BillingStatus from "../../../../types/billing-status";
import TaxiCorporationBillingType from "../../../../types/taxi-corporation-billing-type";
import TaxiCorporationOrderBillingsListParams, {
  TaxiCorporationOrderBillingsListParamsOrder,
} from "./taxi-corporation-order-billings-list-params";

const createBillingModel = (
  status: BillingModel | undefined,
): TaxiCorporationOrderBillingsListRequestBillingModel | undefined => {
  switch (status) {
    case BillingModel.AB:
      return TaxiCorporationOrderBillingsListRequestBillingModel.AB;
    case BillingModel.ABA:
      return TaxiCorporationOrderBillingsListRequestBillingModel.ABA;
    case BillingModel.OTHER:
      return TaxiCorporationOrderBillingsListRequestBillingModel.OTHER;
    case BillingModel.SABS:
      return TaxiCorporationOrderBillingsListRequestBillingModel.SABS;
    default:
      return undefined;
  }
};

const createBillingType = (
  status: TaxiCorporationBillingType | undefined,
): TaxiCorporationOrderBillingsListRequestBillingType | undefined => {
  switch (status) {
    case TaxiCorporationBillingType.PRIV_CARGO_2_TAXI:
      return TaxiCorporationOrderBillingsListRequestBillingType.PRIV_CARGO_2_TAXI;
    case TaxiCorporationBillingType.PRIV_TAXI_2_RAILY:
      return TaxiCorporationOrderBillingsListRequestBillingType.PRIV_TAXI_2_RAILY;
    case TaxiCorporationBillingType.PUB_RAILY_2_TAXI:
      return TaxiCorporationOrderBillingsListRequestBillingType.PUB_RAILY_2_TAXI;
    default:
      return undefined;
  }
};

const createOrder = (
  order: TaxiCorporationOrderBillingsListParamsOrder | undefined,
): TaxiCorporationOrderBillingsListRequestOrder | undefined => {
  switch (order) {
    case TaxiCorporationOrderBillingsListParamsOrder.BILLING_MODEL_ASC:
      return TaxiCorporationOrderBillingsListRequestOrder.BILLING_MODEL_ASC;
    case TaxiCorporationOrderBillingsListParamsOrder.BILLING_MODEL_DESC:
      return TaxiCorporationOrderBillingsListRequestOrder.BILLING_MODEL_DESC;
    case TaxiCorporationOrderBillingsListParamsOrder.DISTANCE_AMOUNT_ASC:
      return TaxiCorporationOrderBillingsListRequestOrder.DISTANCE_AMOUNT_ASC;
    case TaxiCorporationOrderBillingsListParamsOrder.DISTANCE_AMOUNT_DESC:
      return TaxiCorporationOrderBillingsListRequestOrder.DISTANCE_AMOUNT_DESC;
    case TaxiCorporationOrderBillingsListParamsOrder.DISTANCE_ASC:
      return TaxiCorporationOrderBillingsListRequestOrder.DISTANCE_ASC;
    case TaxiCorporationOrderBillingsListParamsOrder.DISTANCE_DESC:
      return TaxiCorporationOrderBillingsListRequestOrder.DISTANCE_DESC;
    case TaxiCorporationOrderBillingsListParamsOrder.DISTANCE_RATE_ASC:
      return TaxiCorporationOrderBillingsListRequestOrder.DISTANCE_RATE_ASC;
    case TaxiCorporationOrderBillingsListParamsOrder.DISTANCE_RATE_DESC:
      return TaxiCorporationOrderBillingsListRequestOrder.DISTANCE_RATE_DESC;
    case TaxiCorporationOrderBillingsListParamsOrder.HALTING_AMOUNT_ASC:
      return TaxiCorporationOrderBillingsListRequestOrder.HALTING_AMOUNT_ASC;
    case TaxiCorporationOrderBillingsListParamsOrder.HALTING_AMOUNT_DESC:
      return TaxiCorporationOrderBillingsListRequestOrder.HALTING_AMOUNT_DESC;
    case TaxiCorporationOrderBillingsListParamsOrder.HIGHWAY_CHARGE_ASC:
      return TaxiCorporationOrderBillingsListRequestOrder.HIGHWAY_CHARGE_ASC;
    case TaxiCorporationOrderBillingsListParamsOrder.HIGHWAY_CHARGE_DESC:
      return TaxiCorporationOrderBillingsListRequestOrder.HIGHWAY_CHARGE_DESC;
    case TaxiCorporationOrderBillingsListParamsOrder.HUMAN_ID_ASC:
      return TaxiCorporationOrderBillingsListRequestOrder.HUMAN_ID_ASC;
    case TaxiCorporationOrderBillingsListParamsOrder.HUMAN_ID_DESC:
      return TaxiCorporationOrderBillingsListRequestOrder.HUMAN_ID_DESC;
    case TaxiCorporationOrderBillingsListParamsOrder.TOTAL_AMOUNT_ASC:
      return TaxiCorporationOrderBillingsListRequestOrder.TOTAL_AMOUNT_ASC;
    case TaxiCorporationOrderBillingsListParamsOrder.TOTAL_AMOUNT_DESC:
      return TaxiCorporationOrderBillingsListRequestOrder.TOTAL_AMOUNT_DESC;
    default:
      return undefined;
  }
};

const createBillingStatus = (
  status: BillingStatus | undefined,
): TaxiCorporationOrderBillingsListRequestStatus | undefined => {
  switch (status) {
    case BillingStatus.ACCEPTED:
      return TaxiCorporationOrderBillingsListRequestStatus.ACCEPTED;
    case BillingStatus.CREATED:
      return TaxiCorporationOrderBillingsListRequestStatus.CREATED;
    case BillingStatus.REJECTED:
      return TaxiCorporationOrderBillingsListRequestStatus.REJECTED;
    case BillingStatus.REOPENED:
      return TaxiCorporationOrderBillingsListRequestStatus.REOPENED;
    case BillingStatus.REOPEN_REQUEST:
      return TaxiCorporationOrderBillingsListRequestStatus.REOPEN_REQUEST_SENT;
    default:
      return undefined;
  }
};

const create = (
  params: TaxiCorporationOrderBillingsListParams,
): TaxiCorporationOrderBillingsListRequest => {
  return {
    limit: params.limit,
    offset: params.offset,
    taxiCorporationUuid: params.taxiCorporationUuid,
    billingModel: createBillingModel(params.billingModel),
    billingType: createBillingType(params.billingType),
    cargoCompany: params.cargoCompany,
    dateSince: params.dateSince,
    dateTo: params.dateTo,
    excludeCargoCompany: params.excludeCargoCompany,
    humanId: params.humanId,
    order: createOrder(params.order),
    passenger: params.passenger,
    planEntryHumanIds: params.planEntryHumanIds,
    responsibleTaxi: params.responsibleTaxi,
    status: createBillingStatus(params.status),
  };
};

const taxiCorporationOrderBillingsListParamsFactory = {
  create,
};

export default taxiCorporationOrderBillingsListParamsFactory;
